import { useEffect, useRef } from 'react';
import { PLATFORM } from '@constants/index';
import { useRouting } from '@hooks/useRouting';
import { capitalize } from '@utils/index';
import { useTranslation } from 'react-i18next';
import { triggerAction } from './SessionMain/heplers';
import { useLocation } from 'react-router-dom';

export default function SessionExpired() {
  const { redirectTo, queryParams } = useRouting();
  const { t } = useTranslation();
  const { platform } = queryParams;
  const location = useLocation();
  const data = location.state;
  const hasTriggeredKioskBackRef = useRef(false);

  useEffect(() => {
    if (platform !== PLATFORM.KIOSK || hasTriggeredKioskBackRef.current) return;

    triggerAction({
      type: 'toBack',
      data: { sessionId: data?.userSessionId || '' },
    });
    hasTriggeredKioskBackRef.current = true;
  }, [data?.userSessionId, platform]);

  const handleRestartSession = (e) => {
    if (platform === PLATFORM.KIOSK) {
      e.preventDefault();
      const payload = { type: 'cancel', data: { sessionId: data?.userSessionId || '' } };

      triggerAction(payload);
      return;
    }

    redirectTo(`/`);
    window.location.reload();
  };

  return (
    <div className="flex h-screen w-screen">
      <img
        alt="background"
        className="h-full w-full object-cover absolute top-1/2 -translate-y-1/2 -z-[1]"
        src="/images/bg.png"
      />
      <div className="relative bg-white shadow-lg p-5 m-auto w-10/12 md:w-5/12">
        <h2 className="h-10 mt-6 overflow-visible text-2xl lg:text-2.5xl font-semibold leading-9 text-black">
          {t('sessionExpiredTitle')}
        </h2>
        <div className="h-8"></div>
        <p className="text-base font-normal">{t('sessionExpiredMessage')}</p>
        <div className="h-8"></div>
        <button
          className="flex justify-center px-4 py-2 mr-4 text-sm font-medium text-white bg-blue-500 border border-transparent rounded shadow-sm -full disabled:hover:bg-gray-500 disabled:bg-gray-500 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={handleRestartSession}
        >
          {capitalize(t('restartSession'))}
        </button>
      </div>
    </div>
  );
}
